import React, { FC, memo, useMemo } from 'react'
import styled, { StyledProps } from 'styled-components'
import { EColor, EColorBgText } from '@ucheba/utils/helpers/styles/variables'
import { Grid, GridCol } from '@ucheba/ui/components/Grid/desktop'
import { Logo } from '@ucheba/ui/components/Logo/desktop'
import { Container } from '@ucheba/ui/components/Container/desktop'
import { Spacing } from '@ucheba/ui/components/Spacing/desktop'
import { Heading } from '@ucheba/ui/components/Heading/desktop'
import { Text } from '@ucheba/ui/components/Text/desktop'
import { Picture } from '@ucheba/ui/components/Picture'
import { IEventBrandingUchebaProps } from '../../../types'
import { useEventsListItemDate } from '../../../../EventsList/bll'

const Block = styled.div<StyledProps<any>>`
  background-color: ${(props) => EColor[props.color]};
  padding: 48px 0;
`

const Chip = styled.div<StyledProps<any>>`
  display: inline-block;
  font-size: 14px;
  line-height: 24px;
  padding: 2px 12px;
  background-color: #ffce08;
  color: ${(props) => EColor[EColorBgText[props.color]]};
  border-radius: 16px;
`

const Image = styled.img`
  width: 100%;
  max-height: 370px;
`

const LogoInstitution = styled(Picture)`
  height: 50px;
`

const EventHeroBrandingUcheba: FC<IEventBrandingUchebaProps> = (props) => {
  const { branding, rubric, name, description, institution, isFinished } = props

  const contentCols = useMemo(() => {
    if (branding) {
      return branding.headerImagePath ? 11 : 24
    }

    return 24
  }, [branding])

  const { format, date } = useEventsListItemDate(props)

  const newDate = date?.split(',')

  const rubricName = useMemo(() => {
    if (rubric) {
      if (rubric.id === 4) {
        return `Вебинар`
      }

      return rubric.name
    }

    return null
  }, [rubric])

  if (!branding) return null

  return (
    <Block color={branding?.headerBackgroundColor}>
      <Container>
        <Grid spacing='xlarge' justifyContent='space-between'>
          <GridCol uxs={contentCols}>
            {institution ? (
              <Grid spacing='small' alignItems='center'>
                <GridCol width='auto'>
                  <Logo
                    color={
                      branding?.headerBackgroundColor
                        ? EColorBgText[branding.headerBackgroundColor]
                        : 'blue'
                    }
                    width='102px'
                    height='24px'
                  />
                </GridCol>

                <GridCol width='auto'>
                  <LogoInstitution
                    alt='лого уз'
                    webpUrl={institution.logo.webp}
                    fallbackUrl={institution.logo.fallbackUrl}
                  />
                </GridCol>
              </Grid>
            ) : (
              <Logo
                color={
                  branding?.headerBackgroundColor
                    ? EColorBgText[branding.headerBackgroundColor]
                    : 'blue'
                }
                width='102px'
                height='24px'
              />
            )}

            <Spacing spacing='large' />

            <Grid spacing='xxsmall'>
              {rubricName && (
                <GridCol width='auto'>
                  <Chip color={EColorBgText[branding?.headerBackgroundColor || 'white']}>
                    {rubricName}
                  </Chip>
                </GridCol>
              )}

              {newDate && newDate[0] && (
                <GridCol width='auto'>
                  <Chip color={EColorBgText[branding.headerBackgroundColor || 'white']}>
                    {newDate[0]}
                  </Chip>
                </GridCol>
              )}

              {format && (
                <GridCol width='auto'>
                  <Chip color={EColorBgText[branding.headerBackgroundColor || 'white']}>
                    {format}
                  </Chip>
                </GridCol>
              )}

              {newDate && newDate[1] && (
                <GridCol width='auto'>
                  <Chip color={EColorBgText[branding.headerBackgroundColor || 'white']}>
                    {newDate[1]}
                  </Chip>
                </GridCol>
              )}
            </Grid>

            <Spacing spacing='xxsmall' />

            {isFinished && (
              <Heading
                h1='Мероприятие уже завершено'
                color={EColorBgText[branding.headerBackgroundColor || 'white']}
                spacing='xxsmall'
              />
            )}

            <div
              style={{
                opacity: isFinished ? 0.5 : 1,
              }}
            >
              <Heading
                h1={isFinished ? undefined : name}
                h2={isFinished ? name : undefined}
                color={EColorBgText[branding.headerBackgroundColor || 'white']}
                spacing='xxsmall'
              />
            </div>

            <Text color={EColorBgText[branding.headerBackgroundColor || 'white']}>
              {description}
            </Text>
          </GridCol>

          {branding?.headerImagePath && (
            <GridCol uxs={8}>
              <Image src={branding?.headerImagePath} />
            </GridCol>
          )}
        </Grid>
      </Container>
    </Block>
  )
}

export default memo(EventHeroBrandingUcheba)
